import { z } from "zod";

export const agreementSchema = z.object({
  id: z.number().nullable(),
  agreementId: z.string(),
  agreementType: z.string(),
  agreed: z.boolean(),
  location: z.object({
    lat: z.nullable(z.number()),
    lng: z.nullable(z.number()),
    time: z.nullable(z.number()),
    accuracy: z.nullable(z.number()),
  }),
});
